import * as React from "react";
import { CssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";
import Box from "@mui/joy/Box";
import { SummaryStatCard } from "../../components/dashboard-summary/SummaryStatCard";
import { Typography } from "@mui/joy";
import "../Dashboard.css";
import "./EmployeeDashboard.css";
import { invoiceStatData, invoiceStatsData } from "../../utils/constants";
import EmployeeSidebar from "../../components/EmployeeSidebar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the CSS
import EmployeeCollapseMenu from "./EmployeeCollapseMenu";
import { useGetEmpDashboardDataQuery } from "../../services/invoices/InvoiceApiSlice";
import { red } from "@mui/material/colors";

export default function EmployeeDashboard() {
  const { data: dashboardData, error, isLoading, isFetching } = useGetEmpDashboardDataQuery();

  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Box sx={{ display: "flex", minHeight: "92dvh", background: 'white' }}>
        <EmployeeSidebar />
        <Box sx={{ width: "100%", marginBottom: 4 }} p={3}>
          {isFetching ? (
            <>Loading...</>
          ) : error ? (
            <Typography sx={{ color: "red", margin: "auto", textAlign: "center" }}>Error Fetching Dashboard Data</Typography>
          ) : (
            <EmployeeCollapseMenu data={dashboardData} />
          )}
          {/* <div className="container-outer">
            <div className="container-one">
              {invoiceStatsData?.map((stat) => (
                <div>
                  <SummaryStatCard value={stat.value} label={stat.label} valueColor={stat.color} />
                </div>
              ))}

              <Box sx={{ p: 2 }}>
                <Typography level="h3" component="h1" textAlign="center" mb={2} className="heading-2">
                  Invoices Data
                </Typography>
              </Box>
            </div>
            <div className="container-two">
              {invoiceStatData?.map((stat) => (
                <div>
                  <SummaryStatCard value={stat.value} label={stat.label} valueColor={stat.color} />
                </div>
              ))}
              <Box sx={{ p: 2 }}>
                <Typography level="h3" component="h1" textAlign="center" mb={2} className="heading-2">
                  Invoices Data
                </Typography>
                <PieChartWithLegend data={billsData} /> 
              </Box>
            </div>
          </div> */}
        </Box>
      </Box>
    </CssVarsProvider>
  );
}
